import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@mui/material';


export default function AccountMenu({ user, logout, counter }) {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = React.useState('')
    const letter = user?.username?.substring(0, 1);
    const [profileurl, setprofileurl] = React.useState(user?.profileurl)
    const open = Boolean(anchorEl);

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget); 
    };
    const handleClose = () => { 
        setAnchorEl(null);
    };
    
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                {counter > 0 ?
                    <Badge onClick={() => navigate("/supportdashboard/conversations")} badgeContent={<Typography style={{ color: 'white', fontWeight: "bold" }}>{counter}</Typography>} color='error'>
                        <Typography sx={{ minWidth: 100, cursor: "pointer" }} >Messages</Typography>
                    </Badge> :
                    <Typography onClick={() => navigate("/supportdashboard/conversations")} sx={{ minWidth: 100, cursor: "pointer" }} >Messages</Typography>
                }
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <img className="imagelogoavatar" src={profileurl || require('./../../assets/common/avatar.png')} alt="Profile" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => navigate("/supportdashboard/myaccount")}>
                    <Avatar /> My account
                </MenuItem>
                <Divider />
                {user.type !== 'Agent' &&
                    < MenuItem onClick={() => navigate("/supportdashboard/agents")}>
                        <ListItemIcon>
                            <PersonAdd fontSize="small" />
                        </ListItemIcon>
                        Add another account
                    </MenuItem>}
                <MenuItem onClick={() => {
                    handleClose()
                    logout()
                }}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </React.Fragment >
    );
}